import {AnyAction} from 'redux';
import {
  SET_REMITTANCE_RESPONSE,
  CLEAN_REMITTANCE_RESPONSE,
} from '../actionTypes';
import { profile } from 'console';

export interface RemittanceResponseState {
  id: string;
  action: string;
  timeTransaction: string;
  createdAt: string;
  updatedAt: string;
  sender: {
    id: string;
    dialCountryCode: string;
    phoneNumber: string;
    completePhoneNumber: string;
    profile: {
      firstName?: string;
      lastName?: string;
      avatar?: string;
      birthDate?: string;
      email?: string;
      city?: string;
      province?: string;
      address?: string;
    }
    nickName?: string;
    isActive: boolean;
    streamToken: string;
  }
  recipient: {
    id: string;
    dialCountryCode: string;
    phoneNumber: string;
    completePhoneNumber: string;
    profile: {
      firstName?: string;
      lastName?: string;
      avatar?: string;
      birthDate?: string;
      email?: string;
      city?: string;
      province?: string;
      address?: string;
    }
    nickName?: string;
    isActive: boolean;
    streamToken: string;
  }
  beneficiary: null;
  extraInfo: {
    transactionId?: string;
    exchangeRate?: string;
    sending?: string;
    converting?: string;
    receiving: {
      amount: string;
      currency: string;
    }
    fee?: string;
    isNew: boolean;
    codeRemittance: string;
    appRequested: string;
    cash: boolean;
    store?: string;
  }
  purposedTransactions?: string;
}

const initialState: RemittanceResponseState = {
  id: '',
  action: '',
  timeTransaction: '',
  createdAt: '',
  updatedAt: '',
  sender: {
    id: '',
    dialCountryCode: '',
    phoneNumber: '',
    completePhoneNumber: '',
    profile: {
      firstName: '',
      lastName: '',
      avatar: '',
      birthDate: '',
      email: '',
      city: '',
      province: '',
      address: '',
    },
    nickName: '',
    isActive: false,
    streamToken: '',
  },
  recipient: {
    id: '',
    dialCountryCode: '',
    phoneNumber: '',
    completePhoneNumber: '',
    profile: {
      firstName: '',
      lastName: '',
      avatar: '',
      birthDate: '',
      email: '',
      city: '',
      province: '',
      address: '',
    },
    nickName: '',
    isActive: false,
    streamToken: '',
  },
  beneficiary: null,
  extraInfo: {
    transactionId: '',
    exchangeRate: '',
    sending: '',
    converting: '',
    receiving: {
      amount: '',
      currency: '',
    },
    fee: '',
    isNew: false,
    codeRemittance: '',
    appRequested: '',
    cash: false,
    store: '',
  },
  purposedTransactions: ''
};

export default (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_REMITTANCE_RESPONSE:
      return {
        ...state,
        ...(action.payload || {}),
      };
    case CLEAN_REMITTANCE_RESPONSE: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
};
